import React, { Component } from 'react';
import { Icon } from 'antd';
import ListItem from '../ListItem';
import CardList from '../ListItem/cardList';
import { getFile } from '../../../../../../utils/modelData';
import Card from '../ListItem/card';
import styles from './index.less';
import style from '../ListModule/index.less';

export default class IconListModule51 extends Component {
  getImg = id => {
    return require(`../../images/icon/${id}.svg`);
  };

  render() {
    const { modules = [] } = this.props;
    return (
      <div>
        <div className={styles.iconModule}>
          {modules.map((item, index) => {
            if (index > 7) {
              return null;
            }
            return (
              <div>
                {item.showIconType === 1 && (
                  <span style={{ backgroundImage: `url(${item.fileId})` }} />
                )}
                {item.showIconType === 0 && (
                  <span style={{ backgroundColor: getFile(item, 1) || '#D6D6D6' }}>
                    <img src={this.getImg(getFile(item, 0) || 'home')} alt="" />
                  </span>
                )}
                <span>{item.moduleName}</span>
              </div>
            );
          })}
        </div>
        <section className={style.listModule}>
          {modules.map((item, index) => {
            if (index < 8) {
              return null;
            }
            return (
              <div
                key={`${item.moduleId}${item.moduleName}`}
                className={`list-wrap ${item.showNewidsArr &&
                  item.showNewidsArr.length <= 0 &&
                  'no-sub-list'}`}
              >
                <div className="module-name">
                  <span>{item.moduleName}</span>
                  {item.showNewidsArr && item.showNewidsArr.length > 0 && <Icon type="right" />}
                </div>
                {item.showNewidsArr && item.showNewidsArr.length > 0 && item.moduleType === 1 && (
                  <div className="sub-list-wrap">
                    {item.showNewidsArr.map(ele => {
                      return (
                        <ListItem
                          key={ele.id}
                          summary={ele.summary}
                          coverPicFileUrl={ele.coverPicFileUrl}
                          outputDate={ele.outputDate}
                          title={ele.title}
                          stencilId={5}
                        />
                      );
                    })}
                  </div>
                )}
                {item.showNewidsArr && item.showNewidsArr.length > 0 && item.moduleType === 4 && (
                  <div className="sub-card-wrap">
                    {item.showNewidsArr.map(ele => {
                      return (
                        <Card
                          key={ele.id}
                          summary={ele.summary}
                          coverPicFileUrl={ele.coverPicFileUrl}
                          outputDate={ele.outputDate}
                          title={ele.title}
                        />
                      );
                    })}
                  </div>
                )}
                {item.showNewidsArr && item.showNewidsArr.length > 0 && item.moduleType === 6 && (
                  <div className="sub-cardList-wrap">
                    {item.showNewidsArr.map(ele => {
                      return (
                        <CardList
                          key={ele.id}
                          summary={ele.summary}
                          coverPicFileUrl={ele.coverPicFileUrl}
                          outputDate={ele.outputDate}
                          title={ele.title}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </section>
      </div>
    );
  }
}
